import React, { Fragment } from 'react';
import { Translation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { mapStateToProps } from '../redux/selector/selector';
import { withRouter } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import SVGContact from 'root/components/Icon/SVGContact';
import commonUtil from '../utils/common-util';

class FooterTop extends React.Component {
    isMount = true;
    isInit = false;

    constructor(props) {
        super(props);
        this.state = {
            isHovered: '',
            modal: false,
            content: '',
            liveChatUrl: '',
            contactList: [],
            contactusLink: '/' + this.props.language.countryLanguageKey.toLowerCase().replace('_', '-') + '/contact',
            aboutusLink: '/' + this.props.language.countryLanguageKey.toLowerCase().replace('_', '-') + '/aboutus',
            affLink: '/' + this.props.language.countryLanguageKey.toLowerCase().replace('_', '-') + '/affiliate',
            termsLink: '/' + this.props.language.countryLanguageKey.toLowerCase().replace('_', '-') + '/terms',
            vipLink: '/' + this.props.language.countryLanguageKey.toLowerCase().replace('_', '-') + '/vip',
            referralLink: '/' + this.props.language.countryLanguageKey.toLowerCase().replace('_', '-'),
            showAffiliate: false,
            affiliateLink: '',

            compSettings: {},
        };
        this.toggleHover = this.toggleHover.bind(this);
    }

    componentDidMount() {
        this.isMount = true;
        this.intervalId = setInterval(this.contactGet, 2000);
        if (this.props.portal.settings && !this.isInit) {
            this.commonInit();
            this.isInit = true;
        }
    }

    componentDidUpdate() {
        if (this.props.portal.settings && !this.isInit) {
            this.commonInit();
            this.isInit = true;
        }
    }

    componentWillUnmount() {
        this.isMount = false;
        clearInterval(this.intervalId);
    }

    commonInit() {
        this.initCompSettings().then(() => {
            this.getAffiliateData();
            this.getFollowUs();
            setTimeout(() => {
                this.updateSeoFooterContent();
            }, 150);
        });
    }

    initCompSettings = () => {
        return new Promise((resolve) => {
            // Step 1: Standard way to get from portal settings
            let tempSettings = commonUtil.getSettingFromPortalSettings({
                vm: this,
                settingName: 'footerSettings',
            });

            // Step 2: Massage again to get the specific data you need (Skip if not needed)
            let paymentMethods = commonUtil.getContentByCurrencyLanguage(this, tempSettings.paymentMethods);
            let liscenseList = commonUtil.getContentByCurrencyLanguage(this, tempSettings.liscenseList);
            let certList = commonUtil.getContentByCurrencyLanguage(this, tempSettings.certList);
            let securityList = commonUtil.getContentByCurrencyLanguage(this, tempSettings.securityList);
            const sponsorshipImg = commonUtil.getContentByCurrencyLanguage(this, tempSettings?.sponsorshipImg);

            let compSettings = {
                paymentMethods,
                liscenseList,
                certList,
                securityList,
                sponsorshipImg,
            };

            this.setState({ compSettings }, () => {
                resolve();
            });
        });
    };

    contactGet = () => {
        const { language, screen } = this.props;
        window.SPL_Content.getContact(language.countryLanguageKey, screen.viewType).then((data) => {
            if (this.isMount) {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        const contact = data[i];
                        if (contact.name === 'LiveChat') {
                            this.setState({ liveChatUrl: contact.desc });
                        }
                    }
                }
            }
        });
    };

    getFollowUs = () => {
        const { language, screen } = this.props;
        window.SPL_Content.getFollowUsList(language.countryLanguageKey, screen.viewType).then((res) => {
            if (this.isMount) {
                if (res) {
                    if (this.props.portal.settings?.features?.contactUsHiddenList) {
                      const { contactUsHiddenList } = this.props.portal.settings?.features;
                      res = res.filter((item) => !contactUsHiddenList.includes(item.name));
                    }

                    this.setState({ contactList: res }, () => {
                        let contact = this.state.contactList;

                        for (let i = 0; i < contact.length; i++) {
                            if (contact[i].name === 'Instagram') {
                                contact[i].img = '/public/html/images/footer/ftr_social_ig_of.png';
                                contact[i].imgHover = '/public/html/images/footer/ftr_social_ig_ov.png';
                            } else if (contact[i].name === 'Youtube') {
                                contact[i].img = '/public/html/images/footer/ftr_social_yt_of.png';
                                contact[i].imgHover = '/public/html/images/footer/ftr_social_yt_ov.png';
                            } else if (contact[i].name === 'Facebook') {
                                contact[i].img = '/public/html/images/footer/ftr_social_fb_of.png';
                                contact[i].imgHover = '/public/html/images/footer/ftr_social_fb_ov.png';
                            } else if (contact[i].name === 'FOLLOWUSLINE') {
                                contact[i].img = '/public/html/images/footer/ftr_social_line_of.png';
                                contact[i].imgHover = '/public/html/images/footer/ftr_social_line_ov.png';
                            } else if (contact[i].name === 'Twitter') {
                                contact[i].img = '/public/html/images/footer/ftr_social_twt_of.png';
                                contact[i].imgHover = '/public/html/images/footer/ftr_social_twt_ov.png';
                            } else if (contact[i].name === 'Line') {
                                contact[i].img = '/public/html/images/footer/ftr_social_line_of.png';
                                contact[i].imgHover = '/public/html/images/footer/ftr_social_ig_ov.png';
                            } else if (contact[i].name === 'FOLLOWUSPHONE') {
                                contact[i].img = '/public/html/images/footer/ftr_social_phone_of.png';
                                contact[i].imgHover = '/public/html/images/footer/ftr_social_phone_ov.png';
                                contact[i].src=`tel:${contact[i].src}`
                            } else if (contact[i].name === 'FOLLOWUSFEEDBACK') {
                                contact[i].img = '/public/html/images/footer/ftr_social_feedback_of.png';
                                contact[i].imgHover = '/public/html/images/footer/ftr_social_feedback_ov.png';
                            } else if (contact[i].name === 'FOLLOWUSEMAIL') {
                                contact[i].img = '/public/html/images/footer/ftr_social_mail_of.png';
                                contact[i].imgHover = '/public/html/images/footer/ftr_social_mail_ov.png';
                                contact[i].src=`mailto:${contact[i].src}`
                            } else if (contact[i].name === 'FOLLOWUSCSKH') {
                                contact[i].img = '/public/html/images/footer/ftr_social_cskh_of.png';
                                contact[i].imgHover = '/public/html/images/footer/ftr_social_cskh_ov.png';
                            }
                        }

                        contact = contact.filter((a) => a.name !== 'Zalo');

                        this.setState({ contactList: contact });
                    });
                }
            }
        });
    };

    getAffiliateData = () => {
        const { language } = this.props;

        // first input is whether this is affiliate portal if not then false
        window.SPL_Content.displayAffiliateLink(false, language.countryLanguageKey).then((res) => {
            if (this.isMount) {
                let affiliateLink = res.affiliateLink;

                // only work in staging, uat and prod environment
                let isStagingUat = false;
                if (affiliateLink.indexOf('staging.') >= 0 || affiliateLink.indexOf('uat.') >= 0) {
                    isStagingUat = true;
                }

                const liteAppPrefix = 'lite-app';

                if (isStagingUat) {
                    affiliateLink = affiliateLink.replace('aff.', 'aff-');
                } else if (affiliateLink.indexOf(liteAppPrefix) !== -1) {
                    affiliateLink = affiliateLink.replace(liteAppPrefix, 'aff');
                }

                this.setState({
                    affiliateLink,
                });

                // Only show affiliate link since for vn
                // ms and sg is affiliate link is not public
                if (language?.country?.toLowerCase() === 'vn') {
                    this.setState({
                        showAffiliate: res.showAffiliate,
                    });
                }
            }
        });
    };

    toggleHover(e) {
        this.setState({ isHovered: e });
    }

    contactOnClickFull = (url) => {
        window.open(url, '');
    };

    contactOnClick = (url) => {
        window.open(url, '', 'width=500,height=700,toolbar=no,location=no,directories=no,status=yes,menubar=no,scrollbars=no');
    };
    affiliateOnClick = (url) => {
        window.open(url, '_blank', 'noreferrer');
    };

    termsOnClick = (url) => {
        window.open(url, '', 'width=1025,height=700,toolbar=no,location=no,directories=no,status=yes,menubar=no,scrollbars=no');
    };

    renderContactIcon(contact) {
        const { isHovered } = this.state;
        let contactName = contact.name.toLowerCase();
        let loadHoverIcon = isHovered && isHovered.toLowerCase() === contactName;
        switch (contactName) {
            case 'youtube':
            case 'facebook':
            case 'followusline':
            case 'twitter':
                return <SVGContact name={`${contactName}${loadHoverIcon ? '-on' : ''}`} className={`${contactName}${loadHoverIcon ? '-on' : ''}  pointer`}></SVGContact>;
            default:
                if (loadHoverIcon) {
                    return <LazyLoadImage src={contact.imgHover} alt={contact.imgAlt} className={`footer-img-provider pointer ${contactName}`}></LazyLoadImage>;
                } else {
                    return <LazyLoadImage src={contact.img} alt={contact.imgAlt} className={`footer-img-provider pointer ${contactName}`}></LazyLoadImage>;
                }
        }
    }

    updateSeoFooterContent = () => {
        const { history, language, screen } = this.props;
        let seoContent = document.getElementById('seo-content');
        let copyrightFooterTop = document.getElementById('copyright-container-top');
        let copyrightFooterBtm = document.getElementById('copyright-container-btm');
        let footerBtm = document.getElementById('footer-btm');
        let hostname = window.location.hostname;
        let path = history.location.pathname;

        if (hostname === 'localhost') {
            hostname = window.tempDomain;
        }

        if (path) {
            path = '/' + path.split('/').slice(2).join('/');
        }

        if (screen && screen.isMobile === false && seoContent) {
            seoContent.innerHTML = '';

            window.SPL_Content.getSubSeoFooter(hostname, path, language.countryLanguageKey, 'footer').then((data) => {
                if (data.data) {
                    if (copyrightFooterTop) {
                        copyrightFooterTop.style.display = 'none';
                    }

                    if (copyrightFooterBtm) {
                        copyrightFooterBtm.classList.add('show');
                    }

                    if (footerBtm) {
                        footerBtm.style.display = 'block';
                    }

                    seoContent.innerHTML = data.data;
                } else {
                    if (copyrightFooterTop) {
                        copyrightFooterTop.style.display = 'flex';
                    }

                    if (copyrightFooterBtm) {
                        copyrightFooterBtm.classList.remove('show');
                    }

                    if (footerBtm) {
                        footerBtm.style.display = 'none';
                    }

                    seoContent.innerHTML = '';
                }
            });
        }
    };

    render() {
        let aboutTitle = '';
        let referralRoute = '/myaccount/referral';
        const { language, portal, screen, user } = this.props;
        const { key, currencyLang } = language;
        const { settings } = portal;

        const { compSettings, contactList } = this.state;
        const { paymentMethods, certList, liscenseList, securityList, sponsorshipImg } = compSettings;

        if (screen.isMobile) {
            referralRoute = '/myprofile/referral';
        }

        if (key === 'en') {
            aboutTitle = 'Us';
        } else if (key === 'ms') {
            aboutTitle = 'Kita';
        } else if (key === 'zh-CN') {
            aboutTitle = '我们';
        }

        let curacaoHyperlink = '';
        if (settings && settings.curacaoHyperlink && settings.curacaoHyperlink[currencyLang]) {
            curacaoHyperlink = settings.curacaoHyperlink[currencyLang];
        } else if (settings && settings.curacaoHyperlink && settings.curacaoHyperlink['ALL']) {
            curacaoHyperlink = settings.curacaoHyperlink['ALL'];
        }

        const generateLicenses = (style, title) => {
            return (
                <div className={style}>
                    <p>{title}</p>
                    <div className='brand-item-container'>
                        {liscenseList?.map((item, i) => {
                            const curacaoAction = item?.name === 'curaccao' && curacaoHyperlink ? window.open(curacaoHyperlink, '_blank') : {};
                            return (
                                <Fragment key={i}>
                                    <li key={i} onClick={() => curacaoAction}>
                                        <i className={`icon-${item.name}`}></i>
                                    </li>
                                </Fragment>
                            );
                        })}
                    </div>
                </div>
            );
        };

        const generateFollowUs = (title) => {
            return (
                <div className='follow-us-container'>
                    <p>{title}</p>
                    <div className='brand-item-container align-left'>
                        {contactList.map((contact) => {
                            return (
                                <li
                                    className='follow-item'
                                    key={contact.name}
                                    onClick={() => this.contactOnClickFull(contact.src)}
                                    onMouseEnter={() => this.toggleHover(contact.name)}
                                    onMouseLeave={() => this.toggleHover('')}
                                >
                                    {this.renderContactIcon(contact)}
                                </li>
                            );
                        })}
                    </div>
                </div>
            );
        };

        const generateFooterContent = (style, title, data) => {
            return (
                <div className={style}>
                    <p>{title}</p>
                    <div className='brand-item-container'>
                        {data?.map((item, i) => (
                            <li key={i}>
                                <i className={`icon-${item.name}`}></i>
                            </li>
                        ))}
                    </div>
                </div>
            );
        };

        const generateFooterNav = (t) => {
            // "action" handle for "onClick", "url" handle for "href". listNav item should define either one (url or action)
            const listNav = [
                {
                    url: this.state.aboutusLink,
                    name: t('global:footer.about-us', { title: aboutTitle }),
                },
                {
                    action: (evt) => {
                        evt.preventDefault();
                        this.termsOnClick(this.state.termsLink);
                    },
                    name: t('global:footer.terms-and-condition', 'Terms & Conditions'),
                },
                {
                    url: this.state.vipLink,
                    name: 'VIP',
                },
                {
                    action: (evt) => {
                        evt.preventDefault();
                        this.contactOnClick(this.state.liveChatUrl);
                    },
                    name: t('global:footer.livechat', 'Live Chat'),
                },
                {
                    url: this.state.contactusLink,
                    name: t('global:footer.contact-us', 'Contact Us'),
                },
                ...(this.state.showAffiliate
                    ? [
                          {
                              action: (evt) => {
                                  evt.preventDefault();
                                  this.affiliateOnClick(this.state.affiliateLink);
                              },
                              name: t('global:footer.affiliate', `Affiliate`),
                          },
                      ]
                    : []),
                ...(user?.isLogin
                    ? [
                          {
                              url: this.state.referralLink + referralRoute,
                              name: t('global:footer.referral', `referral`),
                          },
                      ]
                    : []),
            ];
            return (
                <div className='bottom-navbar-container'>
                    {listNav.map((item) => (
                        <li key={item?.name}>
                            <a href={item?.url ?? '#'} onClick={item?.action}>
                                {item?.name}
                            </a>
                        </li>
                    ))}
                </div>
            );
        };

        const generateFooterCopyright = (t) => {
            return (
                <div className={`copyright-container ${!document.getElementById('seo-footer') ? 'show' : ''}`} id='copyright-container-top'>
                    <p>
                        {t('global:footer.all-right-reserved', 'All rights reserved.', {
                            year: new Date().getFullYear(),
                            merchant: window.globMerchantName,
                        })}
                    </p>
                    <span>18+</span>
                </div>
            );
        };

        const generateSponsor = (t) => {
            const title = t('global:global.menu.sponsorship', 'Sponsorship');
            return (
                <div className='sponsor-container'>
                    <p className='f-section-title capitalize-text'>{title?.toLowerCase()}</p>
                    <div className='sponsor-img-wrapper'>
                        <LazyLoadImage
                          className='sponsor-img'
                          src={sponsorshipImg ?? '/public/html/images/footer/sponsor.webp'}
                          alt='Sponsorship'
                          width="100%"
                          height="100%"
                          style={{ objectFit: this.props.screen.isMobile ? 'contain' : 'cover' }}
                        />
                    </div>
                </div>
            );
        };

        const show3Row = liscenseList && certList ? ' w-35' : '';

        const generateWebView = () => {
            return (
                <Translation>
                    {(t) => (
                        <Fragment>
                            <div className='footer-top'>
                                <div className='col-100'>
                                    <div className='col-75'>
                                        <div className='brand-row-container'>
                                            {liscenseList && generateLicenses(`license-container${show3Row}`, t('global:footer.license', 'Licenses'))}
                                            {certList && generateFooterContent(`cert-container${show3Row}`, t('global:footer.certification', 'Certification'), certList)}
                                            {securityList && generateFooterContent('security-container', t('global:footer.security.header', 'Security'), securityList)}
                                        </div>
                                        <div className='brand-row-separator-35' />
                                        <div className='brand-row-container'>
                                            {paymentMethods && generateFooterContent('payment-container', t('global:footer.payment-method', 'Payment Method'), paymentMethods)}
                                            {contactList?.length > 0 && generateFollowUs(t('global:footer.follow-us', 'Follow Us'))}
                                        </div>
                                    </div>
                                    <div className='col-25'>{generateSponsor(t)}</div>
                                </div>

                                <div className='brand-row-separator-70 brand-row-line-separator'></div>
                                <div className='brand-row-separator-35' />
                                <div className='brand-row-container'>
                                    <div className='bottom-navbar-container'>{generateFooterNav(t)}</div>
                                    <div className='footer-row-copyright'>{generateFooterCopyright(t)}</div>
                                </div>
                                <div className='brand-row-separator-60' />
                            </div>

                            <div id='seo-content'></div>
                        </Fragment>
                    )}
                </Translation>
            );
        };

        const generateMobileView = () => {
            return (
                <Translation>
                    {(t) => (
                        <div className='footer-top'>
                            <div className='col-100'>
                                <div className='col-60 brand-row-container d-inline'>
                                    {paymentMethods && generateFooterContent('payment-container', t('global:footer.payment-method', 'Payment Method'), paymentMethods)}
                                    <div className='brand-row-separator-35' />
                                    {securityList && generateFooterContent('security-container', t('global:footer.security.header', 'Security'), securityList)}
                                </div>
                                <div className='col-40'>{generateSponsor(t)}</div>
                            </div>

                            <div className='brand-row-container'>
                                {certList && generateFooterContent('cert-container', t('global:footer.certification', 'Certification'), certList)}
                                {contactList?.length > 0 && generateFollowUs(t('global:footer.follow-us', 'Follow Us'))}
                            </div>

                            {liscenseList && (
                                <div className='brand-row-container'>
                                    <div className='brand-row-separator-35' />
                                    {generateLicenses(`license-container${show3Row}`, t('global:footer.license', 'Licenses'))}
                                </div>
                            )}
                            <div className='brand-row-separator-70 brand-row-line-separator' />
                            <div className='brand-row-separator-35' />
                            <div className='brand-row-container'>{generateFooterNav(t)}</div>
                            <div className='brand-row-separator-35'></div>
                            <div className='brand-row-container footer-row-copyright'>
                                <div className={`powered_by ${!document.getElementById('seo-footer') ? 'show' : ''}`} id='copyright-container-top'></div>
                                {generateFooterCopyright(t)}
                            </div>
                            <div className='brand-row-separator-60' />
                        </div>
                    )}
                </Translation>
            );
        };

        return (
            <div className='bg-footer-top'>
                <div className='content-container'>{screen?.isMobile ? generateMobileView() : generateWebView()}</div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(withTranslation()(withRouter(FooterTop)));
